import { ChevronRight } from 'lucide-react'
import { Link } from 'react-router-dom'

export function PageHero({ title, trail }: { title: string; trail?: string }) {
  const normalizedTitle = title.toLowerCase()
  const isAboutHero = normalizedTitle.includes('giới thiệu')
  const heroImage = normalizedTitle.includes('đào tạo')
    ? '/assets/images/training-main.jpg'
    : normalizedTitle.includes('tin tức')
      ? '/assets/images/news-opening.jpg'
      : '/assets/images/hero-school.jpg'
  const subtitle = normalizedTitle.includes('đào tạo')
    ? 'Chương trình học toàn diện, phát triển năng lực và phẩm chất học sinh'
    : normalizedTitle.includes('tin tức')
      ? 'Cập nhật hoạt động, thông báo và những khoảnh khắc nổi bật của nhà trường'
      : 'Nơi nuôi dưỡng tri thức, nhân cách và khát vọng tương lai'
  const displayTitle = isAboutHero ? 'GIỚI THIỆU\nNHÀ TRƯỜNG' : title

  return (
    <section className="page-hero page-hero--about">
      <div className="container page-hero__content">
        <div className="page-hero__copy">
          <h1>{displayTitle.split('\n').map((line, index) => <span key={line}>{line}{index < displayTitle.split('\n').length - 1 && <br />}</span>)}</h1>
          <p>{subtitle}</p>
          <div><Link to="/">Trang chủ</Link><ChevronRight size={15} /><span>{trail || title}</span></div>
        </div>
        <img src={heroImage} alt={title} />
      </div>
    </section>
  )
}

export function SectionTitle({ children, action }: { children: React.ReactNode; action?: React.ReactNode }) {
  return <div className="section-title"><h2>{children}</h2>{action}</div>
}

export function EmptyState({ title, description }: { title: string; description: string }) {
  return <div className="empty-state"><h3>{title}</h3><p>{description}</p></div>
}
